<strong>{{TR "Anfragen"}}</strong> {{all}}<br>
<small>
({{TR "Heute"}}&nbsp;{{today}} {{TR "Monat"}}&nbsp;{{month}})
</small>
